import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import statusTable from "./modules/statusTable";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { statusTable },
  plugins: [createPersistedState()]
});
